/* TODO: LT-29405 remove this */

import { createAction, createSlice } from '@reduxjs/toolkit';
import type { IDeparture } from '../../../data/models/searcher/departure.model';
import type { IDestination } from '../../../data/models/searcher/destination.model';

export interface SearcherState {
  // Presenter params:
  presenterParams: any;

  // Request ID:
  request_id: string;

  // Country picker:
  destination: IDestination;
  destinationLoading: boolean;
  allCountries: IDestination[];
  availableCountries: IDestination[];
  priorityCountries: IDestination[];
  // Autocomplete:
  autocompleteOptions: IDestination[];
  autocompleteQueryString: string;

  // Data:
  startDate: Date;
  flexDate: boolean;

  // Availability:
  dateNightsAvailable: boolean;

  // Nights:
  nights: number;
  flexNights: boolean;

  // Tourists:
  adults: number;
  kids: number[];

  // Departure:
  departure: IDeparture;
  departuresList: IDeparture[];
  toJS?: any;

  searchUrl: string;
}

const initialState: SearcherState = {
  presenterParams: {},

  request_id: '',

  // Countries picker:
  destination: {} as IDestination,
  destinationLoading: false,
  allCountries: [],
  availableCountries: [],
  priorityCountries: [],
  // Autocomplete:
  autocompleteOptions: [],
  autocompleteQueryString: '',

  // Date:
  startDate: new Date(),
  flexDate: true,

  // Availibility:
  dateNightsAvailable: true,

  // Nights:
  nights: 0,
  flexNights: true,

  // Tourists:
  adults: 2,
  kids: [],

  // Departure:
  departure: {} as IDeparture,
  departuresList: [],

  // Search url:
  searchUrl: '',
};

const name = 'searcher';

const searcher = createSlice({
  name,
  initialState,
  reducers: {},
});

export const initSearcherAction = createAction(`${name}/initSearcherAction`);

export default searcher.reducer;
